import Card from '@/components/ui/Card';

interface CartaoQuandoOndeProps {
  /** Data curta em destaque, ex.: "sáb, 14 nov". */
  quandoPrincipal: string | null;
  /** Hora ou complemento, em cinza, ex.: "a partir das 19h". */
  quandoSecundario?: string | null;
  onde: string | null;
}

// Dois cartões lado a lado: Quando · Onde. A data fica em uma linha e a hora
// desce em cinza; o local ocupa até 2 linhas, sem reticência na primeira.
export default function CartaoQuandoOnde({
  quandoPrincipal,
  quandoSecundario,
  onde,
}: CartaoQuandoOndeProps) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <Card className="p-4">
        <span className="flex h-5 w-5 items-center justify-center text-primary-600">
          <i className="ri-calendar-line text-[18px]" aria-hidden />
        </span>
        <p className="mt-2 text-[11px] font-semibold uppercase tracking-wide text-foreground-400">
          Quando
        </p>
        <p className="mt-0.5 truncate text-[14px] font-bold text-foreground-950">
          {quandoPrincipal ?? 'A definir'}
        </p>
        {quandoSecundario && (
          <p className="mt-0.5 truncate text-[12px] text-foreground-500">{quandoSecundario}</p>
        )}
      </Card>

      <Card className="p-4">
        <span className="flex h-5 w-5 items-center justify-center text-primary-600">
          <i className="ri-map-pin-line text-[18px]" aria-hidden />
        </span>
        <p className="mt-2 text-[11px] font-semibold uppercase tracking-wide text-foreground-400">
          Onde
        </p>
        <p className="mt-0.5 line-clamp-2 text-[14px] font-bold leading-snug text-foreground-950">
          {onde ?? 'A definir'}
        </p>
      </Card>
    </div>
  );
}